/* eslint-disable import/no-extraneous-dependencies */
import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const UniqueDestinationWrapper = styled(Grid)(() => ({
  border: "1px solid #e4e7ec",
  borderRadius: "0.5rem",
}));

export const UniqueDestinationHeader = styled("header")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 4,
  padding: "0.375rem 0.75rem",
  marginBottom: "0.875rem",
  "& span": {
    "&.headerTitle": {
      color: "#308CDB",
      font: "700 18px/24px Manrope",
    },
    "&.destination": {
      color: "#9CA6AF",
      font: "500 14px/21px Manrope",
    },
  },
}));

interface ImageListHeaderProp {
  isHeader?: boolean;
  isFooter?: boolean;
}
export const ImageListHeader = styled("div")(({ isHeader, isFooter }: ImageListHeaderProp) => ({
  display: "grid",
  gridTemplateColumns: ".5fr .25fr .25fr",
  gridTemplateAreas: "'material qty price'",
  backgroundColor: isHeader ? "#F9FAFB" : "",
  padding: isFooter ? "0.75rem 1rem" : ".5rem 1rem",
  borderTop: isFooter ? "2px solid rgba(70, 88, 105, 0.12)" : "",
  "& span": {
    "&.material": {
      gridArea: "material",
      color: isFooter ? "#465869" : "#667085",
      fontWeight: isHeader || isFooter ? 700 : 400,
      fontSize: "12px",
      lineHeight: "16px",
    },
    "&.qty": {
      gridArea: "qty",
      color: isFooter ? "#465869" : "#667085",
      fontWeight: isHeader || isFooter ? 700 : 400,
      fontSize: "12px",
      lineHeight: "16px",
    },
    "&.price": {
      gridArea: "price",
      color: isFooter ? "#465869" : "#667085",
      fontWeight: isHeader || isFooter ? 700 : 400,
      fontSize: "12px",
      lineHeight: "16px",
    },
  },
}));

export const BodySection = styled("div")(() => ({
  maxHeight: 176,
  overflowX: "hidden",
  overflowY: "auto",
}));

const styles = makeStyles(() => ({
  summaryHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "4px 16px",
    background: "#EDF5FB",
    borderRadius: "8px",
    minHeight: 53,
  },
  summaryTitle: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    color: "#465869",
  },
  summaryAddress: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    color: "#9CA6AF",
  },
  summaryList: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4px 16px",
    "& span": {
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      color: "#465869",
    },
  },
  marginTop: {
    marginTop: "8px",
  },
}));

export default styles;
